import { useLazyQuery } from '@apollo/client'
import { ReadBankingAuthorizationDocument } from 'generated/resources/graphql'

export const useBankingAuthorization = () => {
  const [fetchAuthorization, { loading }] = useLazyQuery(ReadBankingAuthorizationDocument)

  const getAuthorizationUrl = async (employeeId: number, redirectUrl: string) => {
    const result = await fetchAuthorization({
      variables: {
        employeeId,
        redirectUrl,
        provider: 'swan',
      },
    })

    const authorization = result.data?.banking?.authorizationsConnection?.nodes[0] || undefined
    return authorization?.authorizationUrl || undefined
  }

  return {
    getAuthorizationUrl,
    loading,
  }
}
